import { createPsd2SyncStore } from "~/stores/psd2SyncStore";

/** The A8 aggregator, for a customer and for a company. */

export const usePsd2SyncStore = createPsd2SyncStore({
    id: 'psd2Sync',
    baseUrl: '/sync/psd2',
});

export const usePsd2BusinessSyncStore = createPsd2SyncStore({
    id: 'psd2BusinessSync',
    baseUrl: '/sync/business/psd2',
});
